/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
/* eslint-disable @typescript-eslint/no-explicit-any */
import { hall } from '@/hall'
import { ModuleBase } from './ModuleBase'
import { MsgIDs } from '@/defines/MsgIDs'
import { base } from '@/base/base'
import { wsClient } from '@/net/WebSocketClient'

export class EggCapsuleModule extends ModuleBase {
  public activityTime = 0
  public status = 0 //(0:stats,1:money,2:已领取,3:过期)',
  public awardGold = 0
  public beginTime = 0
  public endTime = 0
  public nowtime = 0
  public isCanGetGold = false //是否成功领取砖石
  public uerHeadInfo: any = null
  public isOldOpen = false //是否第一次打开
  public hasInfo = false
  public isClickPanel = true
  init(): void {}

  onClear(): void {}

  onLoad(): void {}

  onDestroy(): void {
    this.activityTime = 0
    this.status = 0
    this.awardGold = 0
    this.beginTime = 0
    this.nowtime = 0
    this.endTime = 0
    this.isOldOpen = false
    this.isCanGetGold = false
    this.hasInfo = false
  }

  inits2c(): void {
    ;(hall.s2c as any)['onClientInviteDataAck'] = (msg: any) => {
      if (msg.ret == 0) {
        //uint32 ret = 1;
        //uint32 UserID = 2;   // 玩家ID
        //uint32 CID = 3;      // 玩家渠道ID
        //uint32 Taskstatus = 4;   // 活动状态
        //uint32 Begintime = 5;    // 活动开始时间
        //uint32 Endtime = 6;      // 活动结束时间
        //uint32 Activitytime = 7; // 活动配置时间
        //uint32 Awardgold = 8;    // 奖励砖石个数
        this.status = msg.Taskstatus
        this.beginTime = msg.Begintime
        this.endTime = msg.Endtime
        this.activityTime = msg.Activitytime
        this.awardGold = msg.Awardgold
        hall.eventDispatcher.emit(hall.EventDefine.EggCapsuleGoldChange)
        hall.eventDispatcher.emit(hall.EventDefine.ChangeBindActivityRed)
      }
    }

    ;(hall.s2c as any)['onClientInviteGoldAck'] = (msg: any) => {
      if (msg.ret == 0) {
        //uint32 ret = 1;
        //uint32 UserID = 2;   // 玩家ID
        //uint32 CID = 3;      // 玩家渠道ID
        //bool   BGold = 4;     // 是否成功领取砖石
        //uint32 Awardgold = 5; // 奖励砖石个数
        //uint32 Begintime = 6; // 活动开始时间
        //uint32 Endtime = 7;   // 活动结束时间
        //uint32 Activitytime = 8; // 活动配置时间
        //repeated InviteUserAvatar uar = 9;
        this.isCanGetGold = msg.BGold
        this.beginTime = msg.Begintime
        this.endTime = msg.Endtime
        this.nowtime = msg.Nowtime
        this.activityTime = msg.Activitytime
        this.awardGold = msg.Awardgold
        this.uerHeadInfo = msg.uar
        hall.eventDispatcher.emit(hall.EventDefine.EggCapsuleUserChange)
      }
    }

    ;(hall.s2c as any)['onClientInviteTasktStatusAck'] = (msg: any) => {
      if (msg.ret == 0) {
        //uint32 ret = 1;
        //uint32 UserID = 2;      // 玩家ID
        //uint32 CID = 3;         // 玩家渠道ID 0 1
        //uint32 Taskstatus = 4;  // 活动状态
        this.hasInfo = true
        this.status = msg.Taskstatus
        hall.eventDispatcher.emit(hall.EventDefine.EggCapsuleIning)
        hall.eventDispatcher.emit(hall.EventDefine.ChangeBindActivityRed)
        if (this.status == 1 || this.status == 4) {
          //直接请求金币
          this.isOldOpen = true
          this.sendEggCapsuleInfo()
        }

        if (!this.isClickPanel) {
          this.isClickPanel = true
          //打开界面
          //base.uiHudSystem.show("EggCapsulePanel");
        }
      }
    }

    ;(hall.s2c as any)['onClientInviteAddGoldAck'] = (msg: any) => {
      if (msg.ret == 0) {
        //uint32 ret = 1;
        //uint32 UserID = 2;      // 玩家ID
        //uint32 CID = 3;         // 玩家渠道ID
        this.sendEggCapsuleInvite()
        hall.userModule.sendClient2ProxyReqGetBalance()
        hall.eventDispatcher.emit(hall.EventDefine.EggCapsuleAddGold)
      }
    }
  }

  onPreloadData(): void {
    this.sendEggCapsuleInvite()
  }

  sendEggCapsuleInfo() {
    //  if (!hall.network.isConnected()) {
    //     hall.network.connect();
    // }
    const message = {
      UserID: hall.userModule.userId,
      CID: base.channelId,
    }
    wsClient.send(MsgIDs.ClientInviteDataReq, message)
  }

  //好友邀请金币请求
  sendEggCapsuleGold() {
    const message = {
      UserID: hall.userModule.userId,
      CID: base.channelId,
      Begintime: this.beginTime,
      Activitytime: this.activityTime,
      Awardgold: this.awardGold,
    }
    wsClient.send(MsgIDs.ClientInviteGoldReq, message)
  }

  //好友邀请活动状态（第一步）
  sendEggCapsuleInvite() {
    //  if (!wsClient.isConnected()) {
    //     wsClient.connect();
    // }
    const message = {
      UserID: hall.userModule.userId,
      CID: base.channelId,
    }
    wsClient.send(MsgIDs.ClientInviteTasktStatusReq, message)
  }

  //好友邀请完成金币
  sendEggCapsuleAddGold() {
    const message = {
      UserID: hall.userModule.userId,
      CID: base.channelId,
      Awardgold: this.awardGold,
    }
    wsClient.send(MsgIDs.ClientInviteAddGoldReq, message)
  }

  getEggCapsuleRed() {
    let red = false
    if (this.hasInfo && this.status != 2 && this.status != 3) {
      red = true
    }
    return red
  }
}
